
import { Link } from 'react-router';
import { ReactNode } from 'react';

import { FlagSyncLogoWithTitle } from '@/components/svgs/logo';

import { cn } from '@/lib/utils';

import { NavigationMenu } from './navigation.menu';
import { NavigationMobileDrawer } from './navigation.mobile-drawer';

export const Navigation = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <DesktopNavigation>{children}</DesktopNavigation>
      <MobileNavigation>{children}</MobileNavigation>
    </>
  );
};

function DesktopNavigation({ children }: { children: ReactNode }) {
  return (
    <div className="hidden lg:block relative z-50">
      <div className="fixed z-40 top-0 left-0 right-0 max-w-[1512px] mx-auto backdrop-blur-sm xl:border-l xl:border-r bg-background/70 px-4 lg:px-12 2xl:px-24">
        <div className="flex justify-between text-foreground py-6 items-center">
          <div className="flex items-center gap-4">
            <Link to="/">
              <FlagSyncLogoWithTitle className="h-10" />
            </Link>
            <NavigationMenu />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}

function MobileNavigation({ children }: { children: ReactNode }) {
  return (
    <div
      className={cn(
        'lg:hidden flex items-center justify-between px-4 fixed h-14 top-0 w-full bg-background z-50 xl:border-l xl:border-r',
      )}
    >
      <Link to="/">
        <FlagSyncLogoWithTitle className="h-6" />
      </Link>

      <NavigationMobileDrawer>{children}</NavigationMobileDrawer>
    </div>
  );
}
